





















































































import {
  defineComponent, onMounted, reactive, Ref, ref,
} from '@vue/composition-api';
import _ from 'lodash';
import { useRouter, useFormat } from '@ideavivat/vivat-2';

import {
  getWithdraws,
  getWithdrawStats,
  updateWithdraw,
} from '@/api';
import withdrawTableOption from '@/table/Withdraw/withdraw';
import useWithdraw from '@/use/useWithdraw';

import CommonModalWithWithdrawInfo from '@/components/Withdraw/CommonModalWithWithdrawInfo.vue';

const List = defineComponent({
  components: {
    CommonModalWithWithdrawInfo,
  },
  setup() {
    const { router } = useRouter();
    const { enStatus: statusList, thStatus: statusDisplay } = useWithdraw();
    const viewWithdrawItemModal = ref(null);
    const refetchQuery = ref(false);
    const stats = reactive({
      total: 0,
      normal: 0,
      broken: 0,
    });
    async function getStats() {
      const result = await getWithdrawStats({ date: filter.transactionDate, type: 'RETURN' });
      stats.total = result.total;
      stats.normal = result.normal;
      stats.broken = result.broken;
    }
    const pendingSearch = _.debounce(() => {
      refetchQuery.value = true;
    });

    const purchaseRequestTableResult = (data: any) => data.data;
    const filter = reactive({
      code: '',
      type: 'RETURN',
      status: '',
      transactionDate: undefined,
    });
    function clickDateHandler(date: any) {
      if (filter.transactionDate === useFormat.date(date).computerShortDate()) {
        filter.transactionDate = undefined;
      } else {
        filter.transactionDate = useFormat.date(date).computerShortDate();
      }
      pendingSearch();
    }

    // Use with select box
    const selectedItemId: Ref<number[]> = ref([]);
    function selectItem(id: number | string) {
      const hitIndex = selectedItemId.value.indexOf(parseInt(id as string, 10));
      if (selectedItemId.value.indexOf(parseInt(id as string, 10)) > -1) selectedItemId.value.splice(hitIndex, 1);
      else selectedItemId.value.push(parseInt(id as string, 10));
    }

    const onRowClick = (row: { item: { id: number } }) => {
      (viewWithdrawItemModal.value as any).open(row.item.id);
    };

    const selectedMaterial = ref(null);

    const materialPurchaseRequestEditor = ref(null);

    async function updateWithdrawStatus(id: number, status: string) {
      await updateWithdraw(id, { status });
      refetchQuery.value = true;
    }

    onMounted(async () => {
      await getStats();
    });

    return {
      statusList,
      statusDisplay,
      stats,
      filter,
      clickDateHandler,

      withdrawTableOption,
      getWithdraws,
      purchaseRequestTableResult,
      onRowClick,
      viewWithdrawItemModal,

      selectedMaterial,
      selectedItemId,

      materialPurchaseRequestEditor,

      pendingSearch,
      refetchQuery,

      updateWithdrawStatus,
    };
  },
});

export default List;
